import React from 'react';

import { Loader, Theme } from '@cashfree-intl/coherent';

const CustomLoader = () => (
  <Theme>
    <Loader active />
  </Theme>
);

export default CustomLoader;
